/* ==========================================================
   CIGAR DIP™
   Luxury Collection Engine
========================================================== */

(() => {

"use strict";

/* ---------- Mouse Spotlight ---------- */

document.addEventListener("mousemove",(e)=>{

document.documentElement.style.setProperty(
"--mouse-x",
e.clientX+"px"
);

document.documentElement.style.setProperty(
"--mouse-y",
e.clientY+"px"
);

});

/* ---------- Scroll Reveal ---------- */

const items=document.querySelectorAll(

".collection-grid-item,.cd-stat,.cd-title,.cd-subtitle"

);

const observer=new IntersectionObserver((entries)=>{

entries.forEach(entry=>{

if(entry.isIntersecting){

entry.target.classList.add("is-visible");

}

});

},{
threshold:.15
});

items.forEach(item=>{

item.classList.add("cd-reveal");

observer.observe(item);

});

/* ---------- Tilt ---------- */

document.querySelectorAll(".collection-grid-item")

.forEach(card=>{

card.addEventListener("mousemove",(e)=>{

const r=card.getBoundingClientRect();

const x=e.clientX-r.left;

const y=e.clientY-r.top;

const rx=(.5-y/r.height)*8;

const ry=(x/r.width-.5)*8;

card.style.transform=
`perspective(1200px)
rotateX(${rx}deg)
rotateY(${ry}deg)
translateY(-8px)`;

});

card.addEventListener("mouseleave",()=>{

card.style.transform="";

});

});

})();
/* ==========================================================
   Luxury Motion Polish
========================================================== */

(() => {

const hero = document.querySelector(".cd-collections-hero");

if(hero){

window.addEventListener("scroll",()=>{

const offset = window.scrollY * 0.18;

hero.style.transform = `translateY(${offset}px)`;

},{passive:true});

}

/* Smooth Card Entrance */

const cards = document.querySelectorAll(".collection-grid-item");

cards.forEach((card,index)=>{

card.style.animationDelay = `${index * 0.08}s`;

});

/* Mouse Ambient Glow */

cards.forEach(card=>{

card.addEventListener("mousemove",e=>{

const rect = card.getBoundingClientRect();

card.style.setProperty("--mx",(e.clientX-rect.left)+"px");

card.style.setProperty("--my",(e.clientY-rect.top)+"px");

});

});

})();